import { render } from "./ModalNotifyError.vue?vue&type=template&id=710d416f"
import script from "./ModalNotifyError.vue?vue&type=script&lang=js"
export * from "./ModalNotifyError.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__